export default class Sitemap {
    constructor () {
        this.initEvents();
    }

    initEvents () {
        this.displayBackground();
    }

    /**
     * Display the background according to the time of day
     */
    displayBackground() {
        const sitemapPage = document.getElementsByClassName('site-plan-page')[0];
        let now = new Date();
        if (sitemapPage) {
            if (window.innerWidth > 1000) {
                if (now.getHours() < 8 || now.getHours() > 20) {
                    sitemapPage.style.background = "url(../images/sitemap_dark.svg) no-repeat right 20% top 50%";
                } else {
                    sitemapPage.style.background = "url(../images/sitemap_light.svg) no-repeat right 20% top 50%";
                }
            } else {
                sitemapPage.style.background = "none";
            }
        }
    }
}
